import React from 'react'

const NotFound = () => {
  return (
    <div className='d-flex w-100 justify-content-center align-items-center' style={{height:"80vh"}}>404! Page NotFound</div>
  )
}

export default NotFound